import React from "react";
import { withStyles } from "@material-ui/core/styles";
import styles from "./styles";
import Paper from "@material-ui/core/Paper";
import InputBase from "@material-ui/core/InputBase";
import IconButton from "@material-ui/core/IconButton";
import AddIcon from "@material-ui/icons/Add";
import EditIcon from "@material-ui/icons/Edit";
import SearchIcon from "@material-ui/icons/Search";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Card from "@material-ui/core/Card";
import DeleteIcon from "@material-ui/icons/Delete";
import Dialog from "@material-ui/core/Dialog";
import TextField from "@material-ui/core/TextField";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Typography from "@material-ui/core/Typography";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import { Button } from "@material-ui/core";
import SnackBar from "../../SnackBar";
const firebase = require("firebase");
require("firebase/firestore");

function getColTitle(data) {
  switch (data) {
    case 0:
      return "Tipo";

    case 1:
      return "Materia";

    case 2:
      return "Materia";

    case 3:
      return "Materia";

    case 4:
      return "Ubicacion";

    default:
      return "Ubicacion";
  }
}

class Catalogos extends React.Component {
  constructor() {
    super();
    this.state = {
      text: "",
      materia: "",
      activo: true,
      open: false,
      isEdit: false,
      idElem: "",
      searchTerm: "",
      seccion: "tribunales",
      indexTab: 0,
      bancos: null,
      guardado: false,
      open2: false,
      noteId: "",
    };
  }
  componentDidMount = () => {
    firebase
      .firestore()
      .collection("datosAutocompletado")
      .orderBy("text", "asc")
      .onSnapshot((serverUpdate) => {
        const bancos = serverUpdate.docs.map((_doc) => {
          const data = _doc.data();
          data["id"] = _doc.id;
          return data;
        });
        this.setState({ bancos });
      });
  };
  returnArrAuto = (data) => {
    switch (data) {
      case 0:
        return ["Estatal", "Federal"];
      case 1:
        return this.state.bancos
          ? this.state.bancos
              .filter((item) => item.seccion === "materia" && item.activo)
              .map((obj) => obj.text)
          : [];
      case 2:
        return [];
      case 3:
        return this.state.bancos
          ? this.state.bancos
              .filter((item) => item.seccion === "materia" && item.activo)
              .map((obj) => obj.text)
          : [];
      case 4:
        return [];
      default:
        return [];
    }
  };
  handleChange = (e) => {
    this.setState({ text: e.target.value });
  };
  newEntry = () => {
    this.setState({ open: !this.state.open });
  };
  handleAdd = async () => {
    if (
      this.state.text.length > 0 &&
      (this.state.materia.length > 0 || this.state.indexTab === 2)
    ) {
      if (!this.state.isEdit) {
        if (
          this.state.bancos.filter((i) => i.text === this.state.text).length ===
          0
        ) {
          await firebase.firestore().collection("datosAutocompletado").add({
            text: this.state.text,
            materia: this.state.materia,
            seccion: this.state.seccion,
            activo: this.state.activo,
          });
          this.setState({
            text: "",
            materia: "",
            isEdit: false,
            idElem: "",
            open: !this.state.open,
          });
          this.handleClick();
        } else {
          this.setState({
            text: "",
            materia: "",
          });
          console.log("El campo ya ha sido agregado previamente");
        }
      } else {
        await firebase
          .firestore()
          .collection("datosAutocompletado")
          .doc(this.state.idElem)
          .update({
            text: this.state.text,
            materia: this.state.materia,
            activo: this.state.activo,
          });
        this.setState({
          text: "",
          materia: "",
          isEdit: false,
          idElem: "",
          open: !this.state.open,
        });
        this.handleClick();
      }
    } else {
      console.log("Favor de llenar todos los campos");
    }
  };
  handleCloseDialog = () => {
    this.setState({
      text: "",
      materia: "",
      isEdit: false,
      idElem: "",
      open: !this.state.open,
    });
  };
  editNote = async (note) => {
    await this.setState({
      text: note.text,
      materia: note.materia,
      activo: note.activo,
      isEdit: true,
      idElem: note.id,
      open: !this.state.open,
    });
  };
  deleteNote = async (note) => {
    this.setState({ noteId: note.id, open2: !this.state.open2 });
  };
  handleClose = () => {
    this.setState({ guardado: !this.state.guardado });
  };
  handleClick = () => {
    this.setState({ guardado: !this.state.guardado });
  };
  handleClose2 = () => {
    this.setState({ open2: !this.state.open2 });
  };
  eliminar = () => {
    firebase
      .firestore()
      .collection("datosAutocompletado")
      .doc(this.state.noteId)
      .delete();
    this.setState({ noteId: "", open2: !this.state.open2 });
  };
  handleChange = async (item) => {
    await firebase
      .firestore()
      .collection("datosAutocompletado")
      .doc(item.id)
      .update({
        text: item.text,
        materia: item.materia,
        activo: !item.activo,
      });
    this.setState({
      text: "",
      materia: "",
      activo: true,
    });
    this.handleClick();
  };
  render() {
    const { classes } = this.props;
    const { searchTerm } = this.state;

    const filteredData = this.state.bancos
      ? this.state.bancos.filter(
          (item) =>
            item.text
              .toLocaleLowerCase()
              .includes(searchTerm.toLocaleLowerCase()) &&
            item.seccion === this.state.seccion
        )
      : null;
    return (
      <div>
        <div style={{ spacing: "15px" }}>
          <div
            style={{
              width: "100%",
              display: "flex",
            }}
          >
            <div
              style={{
                width: "50%",
                display: "flex",
                justifyContent: "flex-start",
              }}
            >
              <Typography style={{}} variant="h5" gutterBottom>
                Catalogos
              </Typography>
            </div>
            <div
              style={{
                width: "50%",
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <Paper className={classes.root}>
                <InputBase
                  className={classes.input}
                  placeholder="Buscar"
                  onChange={(e) =>
                    this.setState({ searchTerm: e.target.value })
                  }
                  inputProps={{ "aria-label": "busca caso" }}
                />
                <IconButton className={classes.iconButton} aria-label="search">
                  <SearchIcon />
                </IconButton>
              </Paper>
              <Button
                variant="contained"
                color="primary"
                onClick={this.newEntry}
                className={classes.button}
                endIcon={<AddIcon />}
              >
                Nuevo
              </Button>
            </div>
          </div>
          <Paper square style={{ width: "100%", marginTop: "10px" }}>
            <Tabs
              value={this.state.indexTab}
              // onChange={handleChange}
              indicatorColor="secondary"
              textColor="primary"
              variant="fullWidth"
              aria-label="full width tabs example"
            >
              <Tab
                label="Juzgados"
                onClick={() =>
                  this.setState({ indexTab: 0, seccion: "juzgados" })
                }
              />
              <Tab
                label="Tribunales"
                onClick={() =>
                  this.setState({ indexTab: 1, seccion: "tribunales" })
                }
              />
              <Tab
                label="Instituciones"
                onClick={() =>
                  this.setState({ indexTab: 2, seccion: "instituciones" })
                }
              />
              <Tab
                label="Materia"
                onClick={() =>
                  this.setState({ indexTab: 3, seccion: "materia" })
                }
              />
              <Tab
                label="Reclamos"
                onClick={() =>
                  this.setState({ indexTab: 4, seccion: "reclamos" })
                }
              />
            </Tabs>
          </Paper>
        </div>
        <List>
          <Card>
            <ListItem alignItems="flex-start">
              <div className={classes.textSection}>
                <h4 className={classes.itemText} style={{ width: "25%" }}>
                  Nombre
                </h4>
                <h4
                  className={classes.itemText}
                  style={{
                    width: "25%",
                    visibility:
                      this.state.indexTab === 2 ? "hidden" : "visible",
                  }}
                >
                  {getColTitle(this.state.indexTab)}
                </h4>
                <h4 className={classes.itemText} style={{ width: "25%" }}>
                  Estatus
                </h4>
                <h4 className={classes.itemText} style={{ width: "25%" }}>
                  Opciones
                </h4>
              </div>
            </ListItem>
          </Card>
        </List>
        {filteredData ? (
          <List>
            {filteredData.map((item, _index) => {
              return (
                <Card key={_index} className={classes.card}>
                  <ListItem alignItems="flex-start">
                    <div className={classes.textSection}>
                      <h4
                        className={classes.itemText2}
                        style={{ width: "25%" }}
                      >
                        {item.text}
                      </h4>
                      <h4
                        className={classes.itemText2}
                        style={{
                          width: "25%",
                          visibility:
                            this.state.indexTab === 2 ? "hidden" : "visible",
                        }}
                      >
                        {item.materia}
                      </h4>
                      <div
                        className={classes.itemText2}
                        style={{ width: "25%" }}
                      >
                        <FormControlLabel
                          control={
                            <Switch
                              checked={item.activo}
                              color="primary"
                              onChange={() => this.handleChange(item)}
                              value="checkedA"
                              inputProps={{ "aria-label": "primary checkbox" }}
                            />
                          }
                          label={item.activo ? "Activo" : "Inactivo"}
                        />
                      </div>
                      <div
                        className={classes.itemText2}
                        style={{ width: "25%" }}
                      >
                        <DeleteIcon
                          onClick={() => this.deleteNote(item)}
                          className={classes.deleteIcon}
                        />
                        <EditIcon
                          onClick={() => this.editNote(item)}
                          className={classes.editIcon}
                        />
                      </div>
                    </div>
                  </ListItem>
                </Card>
              );
            })}
          </List>
        ) : null}
        <Dialog
          open={this.state.open}
          onClose={this.handleCloseDialog}
          aria-labelledby="form-dialog-title"
        >
          <div style={{ width: "400px" }}>
            <DialogTitle id="form-dialog-title">Nuevo Elemento</DialogTitle>
            <DialogContent>
              <DialogContentText>
                Agregar información necesaria para el catálogo
              </DialogContentText>
              <TextField
                autoFocus
                margin="dense"
                id="name"
                value={this.state.text}
                onChange={(e) => this.setState({ text: e.target.value })}
                label="Nombre"
                type="name"
                fullWidth
              />
              {this.state.indexTab !== 2 ? (
                <Autocomplete
                  id="free-solo-demo"
                  value={this.state.materia}
                  onInputChange={(obj, str) => this.setState({ materia: str })}
                  freeSolo
                  options={this.returnArrAuto(this.state.indexTab)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={getColTitle(this.state.indexTab)}
                      margin="dense"
                      fullWidth
                    />
                  )}
                />
              ) : null}
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleCloseDialog} color="primary">
                Cancelar
              </Button>
              <Button onClick={this.handleAdd} color="primary">
                Guardar
              </Button>
            </DialogActions>
          </div>
        </Dialog>
        {this.state.guardado && (
          <SnackBar
            open={this.state.guardado}
            handleClick={this.handleClick}
            handleClose={this.handleClose}
          />
        )}
        <div>
          <Dialog
            open={this.state.open2}
            onClose={this.handleClose2}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              {"¿Desea eliminar el siguiente elemento?"}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description"></DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleClose2} color="primary">
                Cancelar
              </Button>
              <Button onClick={this.eliminar} color="primary" autoFocus>
                Eliminar
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      </div>
    );
  }
}
export default withStyles(styles)(Catalogos);
